const safpBridgeObj = {
    default: this,
    receiveMessageQueue: [],
    messageHandlers: {},
    _initMessageHandler: undefined,
    platform: function(){
        var userAgent = navigator.userAgent.toLowerCase() || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "android";
        } else if (/(iphone|ipad|ipod|ios)/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return "ios";
        }
        return "unknown";
    },
    isSupport: function(){
        if(window.GovAppBridge){
            return true
        }else if(window.webkit && window.webkit.messageHandlers.GovAppBridge){
            return true
        }
        return false
    },
    _initCallback: function(method, params, args){
        var callIndex = window.mCallBackIndex++;
        if(typeof args.success == 'function') {
            var successName = method + '_success' + callIndex;
            window[successName] = args.success;
            params['success'] = successName;
        }

        if(typeof args.fail == 'function') {
            var failName = method + '_fail' + callIndex;
            window[failName] = args.fail;
            params['fail'] = failName;
        }

        if(typeof args.complete == 'function') {
            var completeName = method + '_complete' + callIndex;
            window[completeName] = args.complete;
            params['complete'] = completeName;
        }
    },
    call: function(method, args, isCallback, hasParams){
        var params = {data:args===undefined? [] : args}
        params['method'] = method

        if(isCallback === true){
            params['_initCallback'] = true
        }
        if(hasParams === true){
            params['_initParams'] = true
        }
        if(args){
            this._initCallback(method, params, args)
        }

        var os = this.platform()
        if(os == 'android' && window.GovAppBridge){
            params = JSON.stringify(params)
            return window.GovAppBridge.postMessage(params);
        } else if(os == 'ios' && window.webkit){
            if(params['success'] || params['fail'] || params['complete']){
                params = JSON.stringify(params)
                window.webkit.messageHandlers.GovAppBridge.postMessage(params);
            }else{
                return prompt("_meta=" + method, JSON.stringify(params));
            }
        } else {
            alert("The platform is not supported.");
        }
        return ""
    },
    init: function(messageHandler){
        if (this._initMessageHandler) {
            throw new Error('Bridge.init called twice');
        }
        this._initMessageHandler = messageHandler;

        var receivedMessages = this.receiveMessageQueue;
        this.receiveMessageQueue = null;

        for (var i = 0; i < receivedMessages.length; i++) {
            this._dispatchMetaMessage(receivedMessages[i])
        }
    },
    _handleMetaMessage: function(data){
        var message = (typeof data === "object") ? data : JSON.parse(data);
        if (this.receiveMessageQueue) {
            this.receiveMessageQueue.push(message);
        }
        this._dispatchMetaMessage(message)
    },
    _dispatchMetaMessage: function(message){
        var handler = undefined;
        var result = message.data;

        if (message.handlerId) {
            handler = this.messageHandlers[message.handlerId];
            if (handler == undefined) {
                handler = this._initMessageHandler;
                result = message;
            }
        }

        if (handler) {
            try {
                handler(result);
            } catch (exception) {
                if (typeof console != 'undefined') {
                    console.log("WARNING: javascript handler threw.", message, exception);
                }
            }
        }
    },
    registerHandler: function(handlerId, handler){
        if (typeof handler == 'function') {
            this.messageHandlers[handlerId] = handler;
        }
    },
    unregisterHandler: function(handlerId){
        if(this.messageHandlers[handlerId]){
            delete this.messageHandlers[handlerId]
        }
    },
    closePage: function(){
        this.call("closePage");
    },
    getAppInfo: function(args){
        this.call("getAppInfo", args, true, false);
    },
    getCurrentLanaguage: function(args){
        return this.call("getCurrentLanaguage");
    },
    facialDetect: function(args){
        this.call("facialDetect", args, true, true);
    },
    checkSoftToken: function(name){
        return this.call("checkSoftToken", {"username": name}, false, true) == "1" ? true : false
    },
    getSoftToken: function(args){
        this.call("getSoftToken", args, true, true);
    },
    startPayment: function(args){
        this.call("startPayment", args, true, true);
    },
    requestIdentity: function(args){
        this.call("requestIdentity", args, true, true);
    },
    isLogin: function(){
        return this.call("isLogin") == "1" ? true : false
    },
    login: function(args){
        this.call("login", args, true, true);
    },
    getToken: function(args){
        this.call("getToken", args, true, true);
    }
};

// !function () {
//     if (window.govapp) return;
//     window.mCallBackIndex = 0;
//     window.govapp = safpBridgeObj;
// }();
export default safpBridgeObj